export const defaultState = {
  linkedBenefitsData: null,
};

export default function linkBenefits(state = defaultState, action) {
  switch (action.type) {
    case 'SET_LINKED_BENEFITS_DATA':
      return Object.assign({}, state, {
        linkedBenefitsData: action.payload,
      });
    case 'RESET_LINKED_BENEFITS_DATA':
      return Object.assign({}, state, {
        ...defaultState,
      });
    case 'SET_RESPONSE_DATA': // ➕ new case
      return {
        ...state,
        responseData: action.payload,
      };
    case 'SET_TIMEOUT_VERIFICATION':
      return {
        ...state,
        timeoutInSeconds: action.payload,
        timeoutKey: Date.now(), // 👈 this ensures uniqueness
      };
    default:
      return state;
  }
}
